import type { ApiResponse } from '@tool-no-hu/shared/types';
import api from '../lib/api';

interface TelegramStatus {
  linked: boolean;
  chatId?: number;
  linkedAt?: string;
}

interface BotInfo {
  username: string | null;
}

export async function linkTelegramService(code: string) {
  const response = await api.post<ApiResponse<void>>('/api/v1/telegram/link', { code });
  return response.data;
}

export async function unlinkTelegramService() {
  const response = await api.post<ApiResponse<void>>('/api/v1/telegram/unlink');
  return response.data;
}

export async function getTelegramStatusService(): Promise<TelegramStatus> {
  const response = await api.get<ApiResponse<TelegramStatus>>('/api/v1/telegram/status');
  return response.data.data ?? { linked: false };
}

export async function getBotInfoService(): Promise<BotInfo> {
  const response = await api.get<ApiResponse<BotInfo>>('/api/v1/telegram/bot-info');
  return response.data.data ?? { username: null };
}
